import { postData } from '../common/api'

export function validate (data) {
    return postData('/de/booking/validate', data)
        .catch(error => console.error(error))
}

export function submit (data) {
    return postData('/de/booking/send', data)
        .catch(error => console.error(error))
}
